import { createApp } from 'vue'
import './style.css'

import App from './App.vue'
import ContactBoxApp from './ContactBoxApp.vue'

window.cla.ContactWizardApp = App;
window.cla.ContactBoxApp = ContactBoxApp;
window.cla.ContactBoxCreateApp = createApp;

//this initializez the contact wizard in dev mode
//in production, this needs to be explicitly initialized, on demand.
let wizardHost = document.getElementById("cla-dev-contacts");
if (wizardHost) {
  createApp(App).mount(wizardHost);
}

//this is meant to support both static (placeholder based) and dynamic initialization (Sitecore views)
let staticPlaceholders = document.querySelectorAll('.contact-box-dev-container');

if (staticPlaceholders) {
  console.log("Found app placeholders. Initializing ContactBox app...");
  staticPlaceholders.forEach(p => {
    createApp(ContactBoxApp).mount(p)
  });
}